import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import styles from './ProjectModalQuestions.module.scss';
import ProjectQuestions from '../../../Dashboard/project/ProjectById/ProjectQuestions';
import EmptyState from '../../../UI/EmptyState/EmptyState';
import { ReactComponent as CommentsIcon } from '../../../../assets/svg/commentPost.svg';
import { ReactComponent as DotPost } from '../../../../assets/svg/dotPost.svg';
import '@github/relative-time-element';

interface Question {
  id: string | number;
  question: string;
  answer?: string;
  created_at?: string;
}

interface ProjectModalQuestionsProps {
  questions: Question[];
  myPerson: boolean;
  projectId: string | number;
}

const ProjectModalQuestions: React.FC<ProjectModalQuestionsProps> = ({
  questions,
  myPerson,
  projectId
}) => {
  const [showQAndA, setShowQAndA] = useState(false);

  const handleAskButton = () => {
    setShowQAndA(true);
  };

  return (
    <>
      <div className={styles.info_questions}>
        <div className={styles.info_questions_header}>
          <MessageCircle size={18} />
          <span>
            {questions.length > 0
              ? `${questions.length} ${questions.length === 1 ? 'pregunta' : 'preguntas'}`
              : 'Preguntas'}
          </span>
        </div>
        <div className={styles.info_questions_list}>
          {questions.length > 0 ? (
            questions.map((question, index) => (
              <div key={question.id || index} className={styles.question_item}>
                <div className={styles.question_header}>
                  <p className={styles.question_text}>{question.question}</p>
                  {question.created_at && (
                    <div className={styles.question_meta}>
                      <DotPost width={20} height={20} />
                      <span className={styles.question_time}>
                        <relative-time lang="es" tense="past" datetime={question.created_at}></relative-time>
                      </span>
                    </div>
                  )}
                </div>
                {question.answer && question.answer.trim().length > 0 ? (
                  <div className={styles.question_answer}>
                    <p className={styles.answer_text}>{question.answer}</p>
                  </div>
                ) : (
                  <p className={styles.no_answer}>No hay respuesta aún.</p>
                )}
              </div>
            ))
          ) : (
            <EmptyState 
              title="Nadie hizo preguntas ¡Hacé la primera!" 
              icon={<CommentsIcon width={30} height={30} />} 
              isPortfolio 
            />
          )}
        </div>
        {!myPerson && (
          <button className={styles.ask_button} onClick={handleAskButton}>
            Preguntar
          </button>
        )}
      </div>

      {showQAndA && (
        <ProjectQuestions
          closeModal={() => setShowQAndA(false)}
          projectId={projectId}
        />
      )}
    </>
  );
};

export default ProjectModalQuestions;
